module.exports = __webpack_public_path__ + "img/check.5ba44011.svg";